import { getMyAbilities } from '../services/rbacService';

export const pathToPermissionKey = (path) => {
  if (!path || path === '/' || path === '') return 'dashboard.view';
  const clean = path.replace(/^\//, '').replace(/\/$/, '');
  if (!clean) return 'dashboard.view';
  return clean.replaceAll('/', '.') + '.view';
};

let cachedAbilities = null;
export const loadAbilities = async () => {
  if (cachedAbilities) return cachedAbilities;
  try {
    cachedAbilities = await getMyAbilities();
  } catch (_) {
    cachedAbilities = {};
  }
  return cachedAbilities;
};

export const canAccessPath = async (path) => {
  const abilities = await loadAbilities();
  const key = pathToPermissionKey(path);
  return !!abilities[key];
};



